import React from "react";
import "./index.scss"


export default class Headbar extends React.Component {

  render() {

    return (
      <div className="header">
        <h1>恰饭萌</h1>
        <h2>もえたかおるこ</h2>
        <h3>SummperPocket群论坛&amp;浦岛水坝汉化组</h3>
      </div>
    )
  }
}